export function applyAgentRowStyles(row, data) {
    // Status column (index 4)
    $('td', row).eq(4).removeClass('text-green-600 text-red-600 font-bold')
        .addClass(data[4] === "Active" ? 'text-green-600' : 'text-red-600')
        .addClass('font-bold');
}

export function applyAgencyRowStyles(row, data) {
    // Status column (index 3)
    $('td', row).eq(3).removeClass('text-green-600 text-red-600 font-bold')
        .addClass(data[3] === "Active" ? 'text-green-600' : 'text-red-600')
        .addClass('font-bold');
}


export function initTables() {
    const commonOptions = {
        responsive: true,
        pageLength: 100,
        lengthMenu: [100, { label: 'All', value: -1 }],
        ordering: false,
        createdRow: function(row, data, dataIndex) {
            if ((dataIndex + 1) % 12 === 0) {
                $(row).addClass('highlighted-table-row');
            }
        }
    };

    const scrollableCommonOptions = {
        ...commonOptions,
        scrollY: '800px',
        scrollCollapse: true,
    };

    new DataTable('#agents-table', {
        order: [[0, 'desc']],
        createdRow: function(row, data, dataIndex) {
            applyAgentRowStyles(row, data);
        },
    });
    new DataTable('#clients-table', {
        order: [[0, 'desc']],
    });
    new DataTable("#agencies-table", {
        order: [[0, 'desc']],
        createdRow: function(row, data, dataIndex) {
            applyAgencyRowStyles(row, data);
        },
    });

    new DataTable("#amortization-table", scrollableCommonOptions);
    new DataTable("#payoff-table", scrollableCommonOptions);
    new DataTable("#payoff-table-2nd-lien", scrollableCommonOptions);
    new DataTable("#payoff-table-2nd-lien-expanded", {
        ...scrollableCommonOptions,
        columnDefs: [
            { width: '80px', targets: 0 },
            { width: '80px', targets: 1 },
            { width: '140px', targets: 2 },
            { width: '140px', targets: 3 },
            { width: '140px', targets: 6 },
            { width: '140px', targets: 7 },
            { width: '140px', targets: 8 },
            { width: '120px', targets: 15 },
        ]
    });
    new DataTable("#comparison-amortization-table", commonOptions);

    const expandedOptions = {
        responsive: false,
        paging: false,
        ordering: false,
        searching: false,
        info: false,
        createdRow: function(row, data, dataIndex) {
            if ((dataIndex + 1) % 12 === 0) {
                $(row).addClass('highlighted-table-row');
            }
        },
        columnDefs: [
            { width: '80px', targets: 0 },
            { width: '105px', targets: 1 },
            { width: '95px', targets: 2 },
            { width: '130px', targets: 3 },
        ]
    };

    new DataTable("#comparison-amortization-table-all", {
        ...expandedOptions,
        columnDefs: [
            { width: '80px', targets: 0 },
            { width: '110px', targets: 1 },
            { width: '80px', targets: 2 },
            { width: '70px', targets: 3 },
        ]
    });
    new DataTable("#comparison-payoff-table-first-lien-all", expandedOptions);
    new DataTable("#comparison-payoff-table-second-lien-all", expandedOptions);

    document.querySelectorAll('table').forEach(function(table) {
        table.classList.add('fade-in');
    });
}
